/* Ported from reference/salesfix-value-map-builder.html (class names in camelCase). The reference is the visual spec; edit here, not there. */
.modes {
  display: inline-flex;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 3px;
}
.modes button {
  border: none;
  background: transparent;
  color: var(--muted);
  font-weight: 700;
  font-size: 13px;
  padding: 7px 16px;
  border-radius: 999px;
  transition: all 0.15s ease;
}
.modes button[aria-pressed="true"] {
  background: var(--blue-d);
  color: #fff;
}
.actions {
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;
}
.btn {
  border: 1px solid var(--border-strong);
  background: var(--surface);
  color: var(--blue-d);
  font-weight: 700;
  font-size: 13px;
  padding: 8px 14px;
  border-radius: 9px;
  transition: all 0.15s ease;
}
.btn:hover {
  border-color: var(--blue-l);
  color: var(--blue-text);
}
.btn.primary {
  background: var(--blue-d);
  border-color: var(--blue-d);
  color: #fff;
}
.btn.primary:hover {
  background: var(--blue-l);
  border-color: var(--blue-l);
  color: #fff;
}
.saveState {
  font-size: 12px;
  color: var(--muted);
  align-self: center;
  min-width: 74px;
}
.modalBack {
  position: fixed;
  inset: 0;
  background: rgba(18, 51, 66, 0.4);
  display: none;
  place-items: center;
  z-index: 50;
  padding: 20px;
}
.modalBack.show {
  display: grid;
}
.modal {
  background: #fff;
  border-radius: var(--radius);
  padding: 24px;
  max-width: 440px;
  width: calc(100% - 32px);
  /* A tall dialog (the Share panel) scrolls inside the window, so every button stays reachable. */
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  box-shadow: 0 20px 60px rgba(18, 51, 66, 0.3);
}
.modal.wide {
  max-width: 640px;
}
.modal h3 {
  font-size: 19px;
  margin-bottom: 6px;
}
.modal p {
  color: var(--muted);
  font-size: 14px;
  margin: 0 0 16px;
}
.modal .row {
  display: flex;
  gap: 10px;
  margin-top: 18px;
  justify-content: flex-end;
}
.modal input,
.modal select {
  width: 100%;
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  margin-bottom: 6px;
}
.toast {
  position: fixed;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%) translateY(20px);
  background: var(--ink);
  color: #fff;
  padding: 11px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  opacity: 0;
  pointer-events: none;
  transition: all 0.25s ease;
  z-index: 60;
}
.toast.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
/* The toolbar's More list (ui/MoreMenu.tsx). */
.more {
  position: relative;
  display: inline-block;
}
.moreList {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 40;
  min-width: 190px;
  display: flex;
  flex-direction: column;
  padding: 6px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(18, 51, 66, 0.18);
}
.moreList[hidden] {
  display: none;
}
.moreList > a,
.moreList > button {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  color: var(--blue-d);
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  padding: 9px 12px;
  border-radius: 7px;
  cursor: pointer;
}
.moreList > a:hover,
.moreList > button:hover,
.moreList > a:focus-visible,
.moreList > button:focus-visible {
  background: var(--bg);
}
